<template>
    <b-overlay
        :show="isLoading"
        spinner-variant="primary"
        variant="light"
        opacity="0.5"
        blur="1px"
        rounded="sm"
    >
        <div>
            <div class="text-right" v-if="historyData.length">
                <b-button @click="exportReport" variant="success">
                    <i class="fa fa-file-excel-o mr-2" />
                    Xuất excel
                </b-button>
            </div>
            <apex-chart
                v-if="historyData.length"
                type="bar"
                :height="300"
                :options="chartOptions"
                :series="series"
            />
            <div v-else class="text-center">
                <div
                    style="
                        font-size: 18px;
                        font-weight: bold;
                        font-family: Helvetica, Arial, sans-serif;
                    "
                >
                    Lịch sử lượng mưa
                </div>
                <div class="mt-4">Không có dữ liệu</div>
            </div>
        </div>
    </b-overlay>
</template>
<script>
import CONSTANTS from '../constants';
// For Excel Export
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
export default {
    props: ['historyData'],
    data() {
        return {
            isLoading: false,
            CONSTANTS
        };
    },
    computed: {
        series() {
            return [
                {
                    data: this.historyData.map((data) => (data.value ? parseFloat(data.value) : 0))
                }
            ];
        },
        chartOptions() {
            let chartOptions = {
                chart: {
                    stacked: false,
                    toolbar: {
                        tools: {
                            download: false,
                            selection: false
                        }
                    }
                },
                colors: [
                    ({ value, seriesIndex, w }) => this.setColorByValue({ value, seriesIndex, w })
                ],
                grid: {
                    show: false,
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                    yaxis: {
                        lines: {
                            show: false
                        }
                    }
                },
                title: {
                    text: 'Lịch sử lượng mưa',
                    align: 'center',
                    floating: false,
                    style: {
                        fontSize: '18px',
                        fontWeight: 'bold'
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '80%',
                        distributed: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: []
                },
                yaxis: {
                    tickAmount: this.historyData.some((item) => item.value > 1) ? 4 : 2
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    x: {
                        show: false
                    },
                    y: {
                        title: {
                            formatter: (seriesName) => 'Lượng mưa:'
                        },
                        formatter: (value) => {
                            return `${value} mm/h`;
                        }
                    },
                    followCursor: true
                }
            };
            // Mapping xaxis data
            let categories = this.historyData.map((item) => item.hour);
            if (categories.length > 4)
                categories = [
                    categories[0],
                    categories[parseInt(categories.length / 4)],
                    categories[parseInt((categories.length / 2 + (categories.length - 1)) / 2)],
                    categories[categories.length - 1]
                ];
            else categories = categories;
            categories = categories.map((item) => {
                if (item < 10) return `0${item}:00`;
                return `${item}:00`;
            });
            chartOptions.xaxis.categories = categories;

            return chartOptions;
        }
    },
    mounted() {
        this.isLoading = true;
        setTimeout(() => {
            this.isLoading = false;
        }, 500);
    },
    methods: {
        setColorByValue({ value, seriesIndex, w }) {
            return value > 60
                ? '#e65100'
                : value > 50
                ? '#f57c00'
                : value > 45
                ? '#ffb300'
                : value > 40
                ? '#ffd54f'
                : value > 30
                ? '#ffee58'
                : value > 20
                ? '#7cb342'
                : value > 15
                ? '#aed581'
                : value > 10
                ? '#1976d2'
                : value > 5
                ? '#42a5f5'
                : '#90caf9';
        },
        exportReport() {
            let report = [];
            for (let i = 0; i < this.historyData.length + 1; i++) {
                const item = this.historyData[i];
                report.push({
                    STT: i === this.historyData.length ? '' : i + 1,
                    'Thời gian(h)':
                        i === this.historyData.length
                            ? 'Tổng(mm)'
                            : item.hour < 10
                            ? `0${item.hour}:00`
                            : `${item.hour}:00`,
                    'Lượng mưa(mm/h)':
                        i === this.historyData.length
                            ? _.reduce(
                                  this.historyData.map((item) => parseInt(item.value)),
                                  (sum, n) => {
                                      return sum + n;
                                  },
                                  0
                              )
                            : item.value
                });
            }
            const worksheet = XLSX.utils.json_to_sheet(report);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const excelFileName = `Dữ liệu lịch sử mưa trạm ${this.historyData[0].stationCode}`;
            this.saveAsExcelFile(excelBuffer, excelFileName);
        },
        saveAsExcelFile(buffer, fileName) {
            const data = new Blob([buffer], { type: EXCEL_TYPE });
            FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
        }
    }
};
</script>